{
  "wordmark": {
    "subtitle": "Панель студии"
  },
  "fields": {
    "emailPlaceholder": "welcome@frameriver.ai",
    "passwordPlaceholder": "••••••••",
    "passwordMinPlaceholder": "Минимум 8 символов",
    "companyNamePlaceholder": "Моя студия"
  },
  "passwordVisibility": {
    "show": "Показать пароль",
    "hide": "Скрыть пароль"
  },
  "theme": {
    "light": "Светлая тема",
    "dark": "Тёмная тема"
  },
  "locale": {
    "label": "Язык",
    "switchToRu": "Переключить на русский",
    "switchToEn": "Переключить на английский",
    "ru": "RU",
    "en": "EN"
  },
  "mascots": {
    "login": {
      "eyebrow": "С возвращением",
      "title": "Снова в студии",
      "subtitle": "Войдите, чтобы продолжить работу над кадрами, раскадровками и рендерами.",
      "features": ["Рендеринг", "Раскадровки", "Команда"]
    },
    "signup": {
      "eyebrow": "Знакомство",
      "title": "Создайте аккаунт",
      "subtitle": "Frama поможет собрать команду и запустить первые проекты студии.",
      "features": ["Совместная работа", "Роли", "Проекты"]
    },
    "forgot": {
      "eyebrow": "Не беда",
      "title": "Вернём доступ",
      "subtitle": "Riv подскажет, как снова попасть в панель студии.",
      "features": ["Поддержка", "Безопасность"]
    },
    "onboarding": {
      "eyebrow": "Добро пожаловать",
      "title": "Начнём работу",
      "subtitle": "Создайте компанию или примите приглашение, чтобы войти в производство.",
      "features": ["Студии", "Приглашения", "Проекты"]
    },
    "invitation": {
      "eyebrow": "Приглашение",
      "title": "Вас ждут в команде",
      "subtitle": "Примите приглашение и присоединитесь к работе студии.",
      "features": ["Команда", "Доступ", "Проекты"]
    },
    "newCompany": {
      "eyebrow": "Новая студия",
      "title": "Своя компания",
      "subtitle": "Создайте компанию — вы станете владельцем и сможете приглашать сотрудников.",
      "features": ["Владелец", "Команда", "Контроль"]
    },
    "oauth": {
      "eyebrow": "Claude / MCP",
      "title": "Подключить ассистента",
      "subtitle": "Claude будет работать в Frame River с теми же правами, что и этот логин.",
      "features": ["Проекты", "Промпты", "Инструменты"]
    }
  },
  "login": {
    "title": "Вход",
    "eyebrow": "С возвращением",
    "heading": "Вход в студию",
    "subtitle": "Войдите, чтобы продолжить работу над проектами.",
    "forgotPassword": "Забыли пароль?",
    "submit": "Войти",
    "submitting": "Вход…",
    "noAccount": "Нет аккаунта?",
    "signupLink": "Регистрация"
  },
  "signup": {
    "title": "Регистрация",
    "eyebrow": "Знакомство",
    "heading": "Создать аккаунт",
    "subtitle": "Несколько шагов — и вы в производстве студии.",
    "invitationBanner": "Приглашение в компанию «{{company}}». После регистрации вы автоматически присоединитесь.",
    "passwordConfirmation": "Повторите пароль",
    "firstNamePlaceholder": "Иван",
    "lastNamePlaceholder": "Иванов",
    "submit": "Создать аккаунт",
    "submitting": "Создание…",
    "hasAccount": "Уже есть аккаунт?",
    "loginLink": "Войти",
    "acceptTerms": "Принимаю",
    "termsLink": "условия использования",
    "acceptPrivacy": "Принимаю",
    "privacyLink": "политику конфиденциальности",
    "acceptOffer": "Принимаю",
    "offerLink": "договор-оферту"
  },
  "forgotPassword": {
    "title": "Восстановление пароля",
    "eyebrow": "Не беда",
    "heading": "Восстановление пароля",
    "subtitle": "Укажите email — мы отправим ссылку для сброса пароля.",
    "submit": "Отправить ссылку",
    "submitting": "Отправка…",
    "backToLogin": "Вернуться ко входу"
  },
  "checkEmail": {
    "title": "Подтвердите email",
    "eyebrow": "Почти готово",
    "heading": "Проверьте почту",
    "subtitle": "Мы отправили ссылку для подтверждения на {{email}}.",
    "subtitleNoEmail": "Мы отправили ссылку для подтверждения на ваш адрес.",
    "resend": "Отправить ещё раз",
    "resending": "Отправка…",
    "backToLogin": "Вернуться ко входу"
  },
  "resetPassword": {
    "title": "Новый пароль",
    "eyebrow": "Почти готово",
    "heading": "Задайте новый пароль",
    "subtitle": "Введите новый пароль для вашего аккаунта.",
    "passwordConfirmation": "Подтверждение пароля",
    "submit": "Сохранить пароль",
    "submitting": "Сохранение…"
  },
  "onboarding": {
    "title": "Добро пожаловать",
    "eyebrow": "Добро пожаловать",
    "heading": "С чего начнём?",
    "subtitle": "Создайте компанию или примите приглашение, чтобы войти в производство.",
    "invitationsSection": "Приглашения",
    "join": "Присоединиться",
    "decline": "Отклонить",
    "suspended": "Доступ к «{{company}}» приостановлен владельцем компании. Чтобы вернуться, обратитесь к нему.",
    "archived": "Компания в архиве. Чтобы вернуть доступ, обратитесь к менеджеру платформы.",
    "firstNamePlaceholder": "Иван",
    "lastNamePlaceholder": "Иванов",
    "ownCompanySection": "Своя компания",
    "ownCompanyDescription": "Создайте новую компанию и станьте её владельцем.",
    "createCompany": "Создать компанию"
  },
  "newCompany": {
    "title": "Новая компания",
    "eyebrow": "Новая студия",
    "heading": "Создать компанию",
    "subtitle": "Вы станете владельцем и сможете приглашать сотрудников.",
    "nameLabel": "Название",
    "submit": "Создать компанию",
    "submitting": "Создание…",
    "offerAccept": "Создавая компанию, вы принимаете условия",
    "offerLink": "договора-оферты"
  },
  "acceptInvitation": {
    "title": "Приглашение в компанию",
    "eyebrow": "Приглашение",
    "roleSubtitle": "Роль в компании «{{role}}» для {{email}}.",
    "seesAllProjects": "Владелец видит все проекты компании.",
    "seesAllProjectsRoles": "Владелец видит все проекты компании. Роли в проектах: {{list}}.",
    "alreadyAccepted": "Приглашение уже принято.",
    "declined": "Приглашение отклонено.",
    "expired": "Срок действия приглашения истёк.",
    "signInPrompt": "Чтобы принять приглашение, зарегистрируйтесь или войдите под {{email}}.",
    "signUp": "Зарегистрироваться",
    "signIn": "Войти",
    "wrongEmail": "Приглашение отправлено на {{email}}. Войдите под этим адресом, чтобы принять.",
    "firstNamePlaceholder": "Иван",
    "lastNamePlaceholder": "Иванов",
    "joinCompany": "Присоединиться к компании"
  }
}
